import { render, staticRenderFns } from "./SupplierLog.vue?vue&type=template&id=5a2669e3"
import script from "./SupplierLog.vue?vue&type=script&lang=js"
export * from "./SupplierLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports